<template>
<div id="container" class="leseraum active">
  <top-menu />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <copyright />
    <div class="fullscreen_background z1 active" v-on:click="clearAllBlasen">
        <img src="/static/assets/leseraum/Hintergrund_2860.jpg"/>
    </div>
  <div class="z2 active sessel"><img src="/static/assets/leseraum/leseraum_Sessel.png"></div>
  <div class="z3 active gigi pointer" ><img src="/static/assets/leseraum/leseraum_Gigi.png" @click="playGigi"></div>
  <div class="z4 active libero"><img src="/static/assets/leseraum/leseraum_Libero.png"></div>
  <div class="z5 active dubix pointer"><img src="/static/assets/leseraum/leseraum_Dubix.png" @click="playDubix"></div>
  <div class="z6 active hui pointer"><img src="/static/assets/leseraum/leseraum_Hui.png" @click="playHui">
  <div class="z9"><img src="/static/assets/leseraum/leseraum_Hui_Lesen.png"></div>
  </div>
  <div class="z10 active fliesstext">Du möchtest gerne wissen, welche spannenden Bücher die Hugidubies gerne lesen? Klicke auf Hugi, Gigi oder Dubix und lerne ihre Lieblingsbücher kennen!</div>
  <div class="z50 active textplaybutton pointer" @click="starttextplay"><img src="/static/assets/alle/Play_Button.png"/></div>

  <div class="z14 active text"><img src="/static/assets/leseraum/leseraum_headline.png"></div>
  <transition name="fade">
  <div class="gigilesen z15" v-if="gigilesen" @click="gigilesen=false"><img src="/static/assets/leseraum/leseraum_Gigi_lesen.png">
  <div class="active gigi_buchansicht">
  <img src="/static/assets/leseraum/gigi_buch.png">
  </div>
  <div class="active gigi_buchtitel">
  <h3>Das magische Baumhaus junior — Das Geheimnis von Olympia</h3>
    <p class="fliesstext">von Mary Pope Osborne<br />Ab 6 Jahren</p>
  </div>
  <vuescrollbar tag="div" class="fliesstext gigitext active">
      <p>Komm mit ins alte Griechenland!<br />
Anne und Philipp reisen mit dem magischen Baumhaus ins alte Griechenland. Dort erleben sie die Olympischen Spiele hautnah. Aber Mädchen dürfen eigentlich gar nicht zusehen! Als sich Anne trotzdem unter die Zuschauer eines spannenden Wagenrennens mischt, geraten die Geschwister in große Schwierigkeiten! Ein buntes Kinderbuch zum Vorlesen und ersten Selberlesen!
</p>
<p>Du findest das magische Baumhaus cool und das alte Griechenland mega interessant? Dann ist dieser super spannende Band genau richtig für dich. Wünsch ihn dir zum Geburtstag, zu Weihnachten oder wann auch immer!</p>
  </vuescrollbar>
  </div>
  </transition>
  <transition name="fade">
  <div class="dubixlesen z15" v-if="dubixlesen" @click="dubixlesen=false"><img src="/static/assets/leseraum/leseraum_Dubix_Lesen.png">
  <div class="active dubix_buchansicht">
  <img src="/static/assets/leseraum/dubix_buch.png">
  </div>
  <div class="active dubix_buchtitel">
  <h3>Der Blauwal — Die unglaubliche Geschichte des größten Tiers, das je gelebt hat</h3>
    <p class="fliesstext">von Andreas Tjernshaugen<br />Ab 8 Jahren</p>
  </div>
  <vuescrollbar tag="div" class="fliesstext dubixtext active">
    <p>Der Blauwal ist das größte Tier, das je gelebt hat! Größer als die größten Dinosaurier. Dieses Buch nimmt uns mit in die faszinierende Welt der Blauwale. Mit der Blauwalmutter und ihrem Jungen machen wir uns auf die Reise durch die Tiefen des Ozeans, halten mit ihnen Ausschau nach dem nächsten Krillschwarm oder sehen, wie der kleine Blauwal das Atmen lernt. Kaum zu fassen, dass wir Menschen dieses fantastische Tier beinahe ausgerottet hätten!</p>
<p>Du magst das Meer und seine riesigen Bewohner, die Blauwale, und du möchtest möglichst viel über sie wissen? Dann wird dich diese großartige Geschichte begeistern. Wünsch dir das Buch bei nächster Gelegenheit!</p>
  </vuescrollbar>
  </div>
  </transition>
  <transition name="fade">
  <div class="huilesen z15" v-if="huilesen" @click="huilesen=false"><img src="/static/assets/leseraum/leseraum_Hui_Lesen.png">
  <div class="active hui_buchansicht">
  <img src="/static/assets/leseraum/hugi_buch.png">
  </div>
  <div class="active hui_buchtitel">
  <h3>Lesenlernen mit Spaß - Minecraft – Geister - bis das Schwein pfeift</h3>
    <p class="fliesstext">von Heiko Wolz und <br>André Sedlaczek<br>Ab 6 Jahren</p>
  </div>
  <vuescrollbar tag="div" class="fliesstext huitext active">
    <p>Ein ewiges Feuer aus Netherstein, um das Dorf vor bösen Kreaturen zu schützen? Eine geniale Idee, findet Stefan. Mit Anna und Brokkoli begibt er sich in den Nether. Doch kaum dort angekommen, fällt Stefans Totem der Unsterblichkeit, das ihn und seine Freunde schützen soll, einem Hoglin ins Maul. Aber nicht nur die schweineähnliche Kreatur verfolgt sie nun auf Schritt und Tritt. Auch die Geister der Unterwelt haben es auf sie abgesehen …!</p>
<p>Wenn du Minecraft-Fan bist, Abenteuer liebst und noch dazu richtig gerne lachst, dann gibt es nur eins: Setz dieses tolle Buch ganz oben auf deine Wunschliste! Dein nächster Geburtstag kommt bestimmt!</p>
  </vuescrollbar>
  </div>
  </transition>
</div>
</template>

<script>
/* eslint-disable */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'

window.$ = window.jQuery = require('jquery')
export default {
  name: 'Leseraum',
  data () {
    return {
      who: 'Leseraum',
      gigilesen: false,
      huilesen: false,
      dubixlesen: false,
      dubixtext: `Henrys Großeltern wohnen in einem richtigen Gespensterschloss! Henry und sein magischer Leopard Leander sollen dort Ferien machen. Dumm nur, dass auch seine eingebildeten Cousinen da sind und sein Zimmer besetzen. Höchste Zeit für einen Gruselstreich! Doch plötzlich spukt es wirklich. Wer wohl dahintersteckt? Zum Glück ist Leopard Leander der weltbeste Geisterjäger! /n/n
      Die lustige magische Geschichte könnte dir auch gefallen? Frag deine Eltern! Vielleicht gibt es einen Anlass, dir das Buch zu schenken.`,
      gigitext: `Meja Meergrün kann es kaum erwarten: Bald ist der Winter vorbei und die ersten warmen Sonnenstrahlen erleuchten die Unterwasserwelt – und das feiern die Lyckhaver immer mit einem großen Fest! Doch da bemerkt Meja, dass jemand fehlt: Wo sind denn die Tintenfischlehrerin Frau Bläck und ihre Schülerinnen? Schwipp-schwapp, macht sich das Meermädchen auf die Suche … und landet vor einem düsteren alten Schiffswrack. Darin lauern allerlei Gefahren! Jetzt muss Meja zeigen, was in ihr steckt! /n/n
      Du findest Unterwasserwelt-Abenteuer spannend? Dann ist dieses Buch genau das richtige für dich. Zum Geburtstag, zu Weihnachten oder wann immer!`,
      huitext: `In Märchen geschehen unglaubliche Dinge! Frösche verwandeln sich in Prinzen, schlaue Geißlein überlisten den Wolf und arme Mädchen werden Prinzessinnen. All diese weltberühmten Märchen haben die Brüder Jacob und Wilhelm Grimm vor langer, langer Zeit gesammelt und aufgeschrieben. In diesem Buch findest du 12 ihrer Märchen mit wunderschönen Bildern und einer CD. Du kannst dir die Märchen also vorlesen lassen oder sie auf CD anhören! /n/n
      Du magst Märchen sehr? Dann muss dieses Buch auf deine Wunschliste für Weihnachten oder deinen nächsten Geburtstag!`
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar
  },
  methods: {
    starttextplay () {
      console.log('starttextplay')
        try {
            window.currentAudioX.pause()
        } catch (e) {
            console.log('pause geht nicht')
        }
        try {
            window.currentAudioX.currentTime = 0
        } catch (e) {
            console.log('pause geht nicht')
        }
        try {
            window.currentAudioX = null
        } catch (e) {
            console.log('pause geht nicht')
        }
        window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Buchtipps.mp3')
        window.currentAudioX.muted = muted
        window.currentAudioX.play()
    },    
    clearAllBlasen: function () {
      console.log('tyoeof window.currentAudio', typeof window.currentAudio)  
      if (typeof window.currentAudioX !== 'undefined') {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      }
      this.dubixlesen = false
      this.gigilesen = false
      this.huilesen = false
    },
    playHui () {
      this.gigilesen = false
      this.dubixlesen = false
      this.huilesen = !this.huilesen
      console.log('tyoeof window.currentAudio', typeof window.currentAudio)  
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch (e) {
          console.log('pause geht ned')
        }
      }
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = undefined
        } catch (e) {
          console.log('pause geht ned')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Hugis_Lesetipp_Minecraft-Geister.mp3')
      window.currentAudioX.muted = window.muted
      window.currentAudioX.play()
      var self = this
      if (!this.huilesen){
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      }
    },
    playDubix () {
      this.huilesen = false
      this.gigilesen = false
      this.dubixlesen = !this.dubixlesen
      console.log('tyoeof window.currentAudio', typeof window.currentAudio)  
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch (e) {
          console.log('pause geht ned')
        }
      }
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = undefined
        } catch (e) {
          console.log('pause geht ned')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Dubix_Lesetipp_Blauwal.mp3')
      window.currentAudioX.muted = window.muted
      window.currentAudioX.play()
      // var self = this
      if (!this.dubixlesen) {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      }
    },
    playGigi () {
      this.huilesen = false
      this.dubixlesen = false
      this.gigilesen = !this.gigilesen  
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch (e) {
          console.log('pause geht ned')
        }
      }
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = undefined
        } catch (e) {
          console.log('pause geht ned')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2022_Gigis_Lesetipp_MagBaumhaus_Olympia.mp3')
      window.currentAudioX.muted = window.muted
      window.currentAudioX.play()
      // var self = this
      if (!this.gigilesen) {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      }
    }
  },  
  mounted () {
    this.$ga.page(this.$router)
    // var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Buchtipps.mp3')
      window.currentAudioX.muted = window.muted
      window.currentAudioX.play()
    }, 1000)
  },
  beforeDestroy () {
    this.clearAllBlasen()
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* LESERAUM */

.leseraum .sessel {
    bottom: 10%;
    left: 13%;
}
.leseraum .gigi {
    bottom: 19%;
    left: 17%;
}
.leseraum .gigi {animation: gigi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.leseraum .libero {
    bottom: 15.5%;
    left: 36.5%;
}
.leseraum .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes libero_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.leseraum .dubix {
    right: 23%;
    top: 38%;
}
.leseraum .dubix {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.leseraum .hui {
    top: 25%;
    right: 38%;
}
.leseraum .hui {animation: hui_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hui_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.leseraum .text {
    top: 27%;
    left: 15.5%;
}

.leseraum #menulayer {
    top: 3.5%;
    right: 22%;
}
/* .leseraum .logoshine{top:0%; left:15%;}
 .leseraum .logo{top: 3%; left: 14%;} */
.leseraum div {position:absolute;
        }
.leseraum div{display:none;}
.leseraum .active{display:block !important;}
.leseraum #leseraum{position: absolute; width: 1920px; height: 1080px;}

.fliesstext {
    bottom: 57.5%;
    left: 15.5%;
    width: 26%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
}

/* Textblasen */

.pointer {cursor: pointer;}
.fliesstext.gigitext {
    top: 63%;
    width: 73%;
    height: 20%;
    overflow-y: scroll;
    overflow-x: hidden;
    left: 85px;
    padding-right: 15px;
    height: 170px;
    position: absolute;
}
.gigi_buchtitel {
    top: 25%;
    left: 42%;
}
.gigi_buchansicht {
    top: 22%;
    left: 2%;
}
.gigilesen {
    display: block !important;
    bottom: 15%;
    left: 32%;
  transition: all 0.5s linear;
}
.fliesstext.dubixtext {
    top: 63%;
    width: 73%;
    height: 20%;
    overflow-y: scroll;
    overflow-x: hidden;
    left: 85px;
    padding-right: 15px;
    height: 170px;
    position: absolute;
}
.dubix_buchtitel {
    top: 25%;
    left: 42%;
}
.dubix_buchansicht {
    top: 22%;
    left: 6%;
}
.dubixlesen {
  bottom: 11%;
  left: 24%;
  transition: all 0.5s linear;
  display: block !important;
}

.fliesstext.huitext {
    top: 63%;
    width: 73%;
    height: 20%;
    overflow-y: scroll;
    overflow-x: hidden;
    left: 85px;
    padding-right: 15px;
    height: 170px;
    position: absolute;
}
.hui_buchtitel {
    top: 25%;
    left: 42%;
}
.hui_buchansicht {
    top: 22%;
    left: 4%;
}
.huilesen {
  bottom: 10%;
  left: 13%;
  transition: all 0.5s linear;
  display: block !important;
}

p.fliesstext {
    width: 310px !important;
    display: block;
}
.logo, .menu{display:inherit !important;}
area, .lautsprecher, .restart, .karte_bottom_01, karte_bottom_02, karte_bottom_03, .minuten_01, .minuten_02, .memo_01, memo_02, .malen_01, .malen_02 {
    cursor: pointer;
}
h3 {
    font-family: FrozenMemory;
    color: #3e3d40;
    font-size: 30px;
    margin-top: -20px;
    display: block;
    width: 270px;
}
.gigi_buchtitel h3 {width:280px;}

.z50.active.textplaybutton.pointer {
    position: absolute;
    top: 356px;
    left: 790px;
    z-index:100;
}
.z50.active.textplaybutton.pointer img {
    width: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/Leseraum.vue